var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"pl-3",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.signOut}},[_c('font-awesome-icon',{staticClass:"opacity-5",attrs:{"icon":"sign-out-alt"}}),_vm._v(" ออกจากระบบ ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }